module.exports = __webpack_public_path__ + "img/linnworks.3c50b02b.png";